import Link from "next/link";
import * as React from "react";
import styles from "./styles.module.css";
import { Breadcrumb, BreadcrumbItem } from "@/types/index";

const Breadcrumb: React.FC<{
	items: Breadcrumb;
}> = ({ items }) => {
	const breadcrumbs = items.map((breadcrumb: BreadcrumbItem) => {
		return (
			<li key={breadcrumb.title}>
				{breadcrumb.active ? (
					breadcrumb.title
				) : (
					<Link href={breadcrumb.href}>{breadcrumb.title}</Link>
				)}
			</li>
		);
	});

	return (
		<div className={styles.breadcrumb}>
			<ul>{breadcrumbs}</ul>
		</div>
	);
};

export default Breadcrumb;
